<template>
  <div class="card-body py-3">
    <h3 v-if="isLoaded" class="mb-0 t-500">
      {{ $options.filters.capitalize(getModuleName(researchGroup, 'research_type', -1)) }}

      <editable v-if="canEdit && !isEmpty(researchGroup.research_types)" :isActive="isEditMode"
        :text="addOrEditText(researchGroup.research_types.length)"
        @create="handleEdit()"
        @cancel="validateBeforeSubmit()">
      </editable>

      <i v-if="isLoaded && (isEmpty(researchGroup.research_types) || !canEdit)" class="fa fa-key d-block pull-right t-placeholder"></i>
    </h3>

    <p v-if="canEdit" class="t-sm mb-0">
      to attract the right kind of collaborators
    </p>

    <!-- render content when is loaded -->
    <template v-if="isLoaded">
      <!-- nothing to show -->
      <p v-if="isEmpty(researchGroup.research_types) && !canEdit" class="mb-0 mt-1 t-sm t-secondary">
        No {{ getModuleName(researchGroup, 'research_type', -1) }} added.
      </p>

      <!-- nothing to show -->
      <p v-if="isEmpty(researchGroup.research_types) && canEdit && !isEditMode" class="mb-0 mt-4 text-center">
        <i class="fa fa-plus d-block t-secondary"></i>
        <a href="#" @click.prevent="handleEdit()" class="t-sm">Add {{ getModuleName(researchGroup, 'research_type', -1) }}</a>
      </p>

      <!-- render research types -->
      <ul v-if="!isEmpty(researchGroup.research_types) && !isEditMode" class="list-unstyled mb-0 mt-3">
        <li class="position-relative" v-for="(research_type, index) in researchGroup.research_types" :key="index">
          <span class="mr-3">{{ research_type.name }}</span>
          <i class='fa fa-info-circle fa-info-absolute fa-info-absolute--right t-sm t-secondary' v-tooltip.top="research_type.description"></i>
        </li>
      </ul>

      <!-- render static messages -->
      <static-messages v-if="error" :messages="error" :variant="`danger`" @closed="error = null"/>

      <!-- edit mode -->
      <form v-if="isEditMode && canEdit && isResearchTypeLoaded" @submit.prevent="validateBeforeSubmit" autocomplete="off" class="mt-3">
        <div class="form-group mb-0" v-for="(researchType, index) in researchTypes" :key="index">
          <checkbox v-model="researchType.checked"
            :text="researchType.name"
            :name="researchType.name"
            v-tooltip.top="researchType.description">
          </checkbox>
          <!-- <p class="mb-0 t-sm t-secondary ">{{ researchType.description }}</p> -->
        </div>

        <form-buttons :isCreateMode="false"
          :isEditMode="true"
          :isRequest="isRequest"
          @cancel="handleEdit()">
        </form-buttons>
      </form>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import Editable from '@/components/shared/Editable'
import StaticMessages from '@/components/shared/StaticMessages'
import Checkbox from '@/components/shared/form/Checkbox'
import FormButtons from '@/components/shared/form/Buttons'

import ResearchTypeService from '@/services/research_type'
import ResearchGroupService from '@/services/research_group'

export default {
  name: 'researchGroupResearchType',
  components: {
    Spinner,
    StaticMessages,
    Checkbox,
    Editable,
    FormButtons
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      error: null,
      isRequest: false,
      isEditMode: false,
      isResearchTypeLoaded: false,
      researchTypes: []
    }
  },
  mounted () {
    if (this.isLoaded) this.fetchResearchTypes()
  },
  watch: {
    isLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) this.fetchResearchTypes()
    }
  },
  methods: {
    fetchResearchTypes () {
      this.isResearchTypeLoaded = false

      ResearchTypeService.get().then(researchTypes => {
        this.researchTypes = researchTypes

        for (let k of this.researchTypes) {
          (this.researchGroup.research_types.filter(x => x.id === k.id)[0])
            ? k.checked = true
            : k.checked = false
        }

        this.isResearchTypeLoaded = true
      }).catch(err => {
        this.error = this.handleError(err)
        this.isResearchTypeLoaded = !this.isEmpty(this.error)
      })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result && !this.isRequest) {
          this.isRequest = true

          let ids = []
          for (let key of this.researchTypes) if (key.checked) ids.push(key.id)

          ResearchGroupService.updateResearchType(this.researchGroup.slug_values[0], { ids: ids }).then(rTypes => {
            this.$events.$emit('research_group:updated', 'research_types', rTypes)
            this.isEditMode = false
            this.isRequest = false
          }).catch(err => {
            this.isRequest = false
            this.error = this.handleError(err)
          })
        }
      })
    },
    handleEdit () {
      this.isEditMode = !this.isEditMode
    }
  }
}
</script>
